import Axios from "axios";

export const SelectBL = (f, g, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BLBRs?type=bl&VENDEUR=${f}&grp=${g}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BL_SELECT", payload: response.data });
    });
  };
};
